export default "__VITE_ASSET__C1DqqKzF__"